import axios from "axios";
import React, { useState, useEffect, createContext } from "react";

export const ManagerAuthConsultant = createContext();

export const ManagerAuthConsultantProvider = ({ children }) => {
  const [currentUserCons, setCurrentUserCons] = useState(
    JSON.parse(localStorage.getItem("AllowConsLog")) || "secuRsp"
  );

  const login = async (inputs) => {
    const res = await axios.post(
      "https://clinic.salamatpayanew.ir/ConsultantLogin",
      inputs
    );
    setCurrentUserCons(res.data);
  };

  const logout = async (inputs) => {
    await axios.post("https://clinic.salamatpayanew.ir/ConsultantLogout");
    setCurrentUserCons("secuRsp");
  };
  useEffect(() => {
    localStorage.setItem("AllowConsLog", JSON.stringify(currentUserCons));
  }, [currentUserCons]);

  return (
    <ManagerAuthConsultant.Provider value={{ currentUserCons, login, logout }}>
      {children}
    </ManagerAuthConsultant.Provider>
  );
};
